import { useForm } from "react-hook-form";
import Logo from "../../assets/img/logos/logoColor.png";
import FormField from "../../components/FormFiel/FormFiel";
import { useState } from "react";
import { useAuthContext } from "../../context/authContext";
import { IoAlertCircleOutline } from "react-icons/io5";

function Login() {
  const { login } = useAuthContext();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    setError("");

    try {
      await login(data); // Suponiendo que login() es tu función de autenticación con Firebase
    } catch (error) {
      // Extraer el código del error de Firebase
      const errorCode = error.code || "UNKNOWN_ERROR";

      switch (errorCode) {
        case "auth/invalid-credential":
          setError(
            "El nombre de usuario o contraseña son incorrectos. Intenta nuevamente."
          );
          break;
        case "auth/user-disabled":
          setError(
            "Este usuario ha sido deshabilitado. Contacta al administrador."
          );
          break;
        case "auth/too-many-requests":
          setError(
            "Has intentado iniciar sesión demasiadas veces. Intenta más tarde."
          );
          break;
        default:
          setError(
            `Ocurrió un error inesperado (${errorCode}). Intenta nuevamente.`
          );
          break;
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="antialiased bg-gradient-to-br from-primary to-white">
      <div className="container px-6 mx-auto">
        <div className="flex flex-col text-center md:text-left md:flex-row h-screen justify-evenly md:items-center">
          <div className="flex flex-col w-full">
            <div className="my-2">
              <img src={Logo} alt="Logo" className="w-28 mx-auto md:mx-0" />
            </div>
            <h1 className="text-3xl text-gray-800 font-bold">
              Inmobiliaria Zapiola
            </h1>
            <p className="w-5/12 mx-auto md:mx-0 text-gray-500">
              Controle y monitoree los datos de su sitio web desde el panel de
              control.
            </p>
          </div>
          <div className="w-full md:w-full lg:w-9/12 mx-auto md:mx-0">
            <div className="bg-white p-10 flex flex-col w-full shadow-xl rounded-xl">
              <h2 className="text-2xl font-bold text-gray-800 text-left mb-5">
                Iniciar Sesión
              </h2>

              {/* Mensaje de error si hay problemas con el login */}
              {error && (
                <p className="flex justify-center items-center text-red-500 text-sm bg-red-100 p-2 rounded-md">
                  <IoAlertCircleOutline className="text-4xl m-2" /> {error}
                </p>
              )}

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="space-y-2">
                  <FormField
                    label="Correo Electrónico"
                    id="email"
                    name="email"
                    required={true}
                    type="email"
                    maxLength={35}
                    minLength={6}
                    placeholder="Correo Electrónico"
                    errors={errors}
                    register={register}
                  />
                  <div className="flex flex-col relative">
                    <FormField
                      label="Contraseña"
                      id="password"
                      name="contraseña"
                      required={true}
                      type="password"
                      minLength={8}
                      maxLength={16}
                      placeholder="Contraseña"
                      errors={errors}
                      register={register}
                    />
                  </div>
                </div>

                <div className="text-center mt-6">
                  <button
                    type="submit"
                    className={`w-full flex justify-center bg-primary hover:bg-secondary text-gray-100 p-3 rounded-lg tracking-wide font-semibold transition ease-in duration-500 ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "cursor-pointer"
                    }`}
                    disabled={loading}
                  >
                    {loading ? (
                      <div className="flex items-center">
                        <svg
                          role="status"
                          className="inline h-6 w-6 animate-spin mr-2 text-gray-200 fill-blue-500"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                        Cargando...
                      </div>
                    ) : (
                      "Iniciar Sesión"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
